import styled from "styled-components"

export const Wrapper = styled.div`
    display: inline-block;
    vertical-align: middle;
    margin-right: 10px;
`

export const HiddenCheckBox = styled.input.attrs({ type: "checkbox" })`
    border: 0;
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    width: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    white-space: nowrap;
`

export const Icon = styled.svg`
    fill: none;
    stroke: var(--white);
    stroke-width: 2px;
`

export const StyledCheckbox = styled.div`
    display: inline-block;
    width: 16px;
    height: 16px;
    background-color: var(--${props => props.bgColor});
    border-radius: 3px;
    transition: all 150ms;

    ${HiddenCheckBox}:focus + & {
        box-shadow: 0 0 0 2px var(--primary);
    }

    ${Icon} {
        visibility: ${props => props.checked ? "visible" : "hidden"}
    }
`
